import { render, staticRenderFns } from "./tencentadgroups-add-or-update.vue?vue&type=template&id=64a37c49&"
import script from "./tencentadgroups-add-or-update.vue?vue&type=script&lang=js&"
export * from "./tencentadgroups-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports